export default __webpack_public_path__ + "static/media/feedback.c25a4369.svg";